// global
//import React from 'react';

import scheduleByFirstApplication from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/calendarEach/scheduleByFirstApplication';
import {
  schedulePerDaySpecificTime,
  schedulePerDayPerShift,
  schedulePerWeekSpecificTime,
  schedulePerWeekPerShift,
  schedulePerMonthSpecificTime,
  schedulePerMonthPerShift
} from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/calendarTimesPer';

import schedulePerShift from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/calendarPerShift/schedulePerDayPerShift';
import convertFrequency from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/utils/convertFrequency';
//consts
import { CALENDAR_TYPE } from 'app/config/calendar_type';
import { TYPE } from '../../../../../../../../config/pad_prescription_suggestion_scheduling';

const execute = function (padPrescription, pad) {
  const {
    EVERY,
    TIMES_PER,
    PER_SHIFT
    //
  } = CALENDAR_TYPE;

  const {
    FIRST_APPLICATION,
    DAY_HOUR,
    DAY_SHIFT,
    WEEK_HOUR,
    WEEK_SHIFT,
    MONTH_HOUR,
    MONTH_SHIFT
    //
  } = TYPE;

  //const  = calendarTimesPer;

  let { /* padPrescriptionId, */ padPrescriptionSuggestionScheduling } = padPrescription;
  let [{ type: suggestionType }] = padPrescriptionSuggestionScheduling;

  //const padPrescription = await padPrescriptionModel.getByID(padPrescriptionId);
  if (
    !padPrescription.calendarType ||
    !padPrescription.frequencyTypeId ||
    !padPrescription.frequencyAmount
  ) {
    const { calendarType, frequencyTypeId, frequencyAmount } = convertFrequency(
      padPrescription.frequency
    );
    padPrescription = {
      ...padPrescription,
      calendarType,
      frequencyTypeId,
      frequencyAmount
    };
  }

  let calendarType = padPrescription.calendarType || EVERY;

  const processSchedulePrescriptionCalendar = {
    [EVERY]: {
      [FIRST_APPLICATION]: scheduleByFirstApplication
    },
    [TIMES_PER]: {
      [DAY_HOUR]: schedulePerDaySpecificTime,
      [DAY_SHIFT]: schedulePerDayPerShift,
      [WEEK_HOUR]: schedulePerWeekSpecificTime,
      [WEEK_SHIFT]: schedulePerWeekPerShift,
      [MONTH_HOUR]: schedulePerMonthSpecificTime,
      [MONTH_SHIFT]: schedulePerMonthPerShift
    },
    [PER_SHIFT]: {
      [DAY_SHIFT]: schedulePerShift
    }
  };

  const isCalendarTypePredicted = Object.values(CALENDAR_TYPE).includes(calendarType);

  if (!isCalendarTypePredicted) {
    throw new Error(`${calendarType} Something wrong!`);
  }

  const isSuggestionTypePredicted = Object.values(TYPE).includes(suggestionType);

  if (!isSuggestionTypePredicted) suggestionType = 'DEFAULT';

  return processSchedulePrescriptionCalendar[calendarType][suggestionType](padPrescription, pad);
};

export default execute;
